import { APP_URL } from "../constants";
import { httpClient } from "../utils/http-client";

const getTransactions = async (
    token,
    { offset = 0, limit = 10, status, type, agent, start, end } = {}
) => {
    try {
        const params = new URLSearchParams();
        params.set("page", String(Number(offset) || 0));
        params.set("size", String(Number(limit) || 10));
        if (status) params.set("status", status);
        if (type) params.set("type", type);
        if (agent) params.set("agent", agent);
        if (start) params.set("start", start);
        if (end) params.set("end", end);
        return httpClient.get(`${APP_URL}/v1/tx?${params.toString()}`, {
            Authorization: `Bearer ${token}`
        })
    } catch (error) {
        console.log("Error getting transactions", error);
    }
}

const getRevenue = async (token) => {
    try {
        return httpClient.get(APP_URL + '/v1/revenue', {
            Authorization: `Bearer ${token}`
        })
    } catch (error) {
        console.log("Error getting revenue", error);
    }
}

const getBalances = async (token) => {
    try {
        return httpClient.get(APP_URL + '/v1/balances', {
            Authorization: `Bearer ${token}`
        })
    } catch (error) {
        console.log("Error getting balances. Please refresh and try again.", error);
    }
}  

const update = async (order, token) => {
    try {
        return httpClient.put(APP_URL + `/v1/tx/admin/${order.id}`, order, {
            Authorization: `Bearer ${token}`
        })
    } catch (error) {
        console.log("Error getting orders", error);
        return error;
    }
}   


export {
    getTransactions, update, getBalances, getRevenue
}